import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DocumentModel } from "../../models/document.model";
import { CerrixAccordionComponent } from "@app/shared/cerrix-accordion-group/cerrix-accordion/cerrix-accordion.component";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DateTimeDisplayPipe } from "../../../pipes/date-time-display.pipe";
import { CerrixIconComponent } from "@app/incident/components/src/lib/core/cerrix-icon/cerrix-icon.component";
import { CerrixIconButtonComponent } from "@app/incident/components/src/lib/core/cerrix-icon-button/cerrix-icon-button.component";

@Component({
    selector: "cerrix-edit-document-history-item",
    imports: [
        CerrixIconComponent,
        CerrixIconButtonComponent,
        MatIconModule,
        MatTooltipModule,
        DateTimeDisplayPipe,
    ],
    templateUrl: "./cerrix-edit-document-history-item.component.html",
    styleUrl: "./cerrix-edit-document-history-item.component.scss",
    providers: [
        { provide: CerrixAccordionComponent, useExisting: CerrixEditDocumentHistoryItemComponent },
    ]
})
export class CerrixEditDocumentHistoryItemComponent extends CerrixAccordionComponent {
    @Input() public document!: DocumentModel;
    @Output() public emitDownload = new EventEmitter<DocumentModel>();

    protected onDownload() {
        this.emitDownload.emit(this.document);
    }
}
